const SectionProductAccess = () => {
  const specialCharacters = "(| ~ \\ ^ ` : ; < = > ? @ ! \" # $ % & ' ( ) * + , . { } [ ] _ - /).";

  return (
    <section id="acesso-produto" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title">Acesso ao equipamento</h5>
        </div>
        <div className="card-body">
          <div className="card">
            <div className="card-body">
              <div className="fw-bold">Primeiro acesso</div>
              <p className="justified-text">O produto pode ser acessado através da interface de gerenciamento web do
                equipamento. Execute o procedimento a seguir para acessar seu equipamento:
              </p>
              <ol className="list-styled">
                <li className="justify-content-between align-items-start">
                  <div className="ms-2 me-auto">
                    <p className="m-0">
                      Conecte um cabo de rede entre seu
                      computador e o equipamento;
                    </p>
                  </div>
                </li>
                <li className="justify-content-between align-items-start">
                  <div className="ms-2 me-auto">
                    <p className="mb-0">
                      Certifique-se de que seu computador se encontra
                      na mesma rede que o equipamento, <strong>ex. 10.0.0.2/24;</strong>
                    </p>
                    <ul>
                      <li>
                        <p className="mb-0">Acesse as configurações de rede de seu computador.</p>
                      </li>
                      <li>dentro da interface que o equipamento estiver conectado (por padrão Ethernet), configure o
                        IPv4 como fixo. <strong>Endereço IP: 10.0.0.2 e máscara de sub-rede: 255.255.0.0</strong>
                      </li>
                      <p className="mt-0"><strong>Obs.:</strong>É possível fazer realizar um ping para o equipamento
                        via terminal para verificar que a configuração foi feita com sucesso. </p>
                    </ul>
                  </div>
                </li>
                <li className="justify-content-between align-items-start">
                  <div className="ms-2 me-auto">
                    <div className="mb-0">
                      Digite o endereço <strong>10.0.0.1</strong> na barra de endereço do navegador;
                    </div>
                  </div>
                </li>
                <li className="justify-content-between align-items-start">
                  <div className="ms-2 me-auto">
                    <div className="mb-0">
                      Se tiver êxito no acesso,
                      a tela de login da imagem abaixo será exibida:
                    </div>
                  </div>
                </li>
              </ol>
              <div className="d-flex justify-content-center img-container">
                <img src="./res/figures/login.png" className="card-img-bottom img-lg" alt="" />
              </div>
              <br />
              <p className="mb-0">Insira as seguintes informações:</p>
              <ul>
                <li>
                  <p className="mb-0"><strong>Usuário:</strong> admin</p>
                </li>
                <li>
                  <p className="mb-0">
                    <strong>Senha:</strong> A senha padrão do equipamento é aleatória e pode ser encontrada
                    na etiqueta do produto, como verificado na imagem abaixo.
                  </p>
                  <br />
                  <div className="d-flex justify-content-center img-container">
                    <img src="./res/figures/senha-etiqueta.png" className="card-img-bottom img-xs" alt="" />
                  </div>
                </li>
                <p className="mb-0">
                  <strong>Obs.:</strong> o idioma português é pré-definido
                  por padrão e pode ser alterado.
                </p>
              </ul>
              <p>A página de primeiro acesso será exibida:</p>
              <div className="d-flex justify-content-center print-image img-container">
                <img src="./res/figures/primeiro-acesso.png" className="card-img-bottom img-lg" id="primeiro-acesso"
                  alt="" />
              </div>
              <ul className="p-2">
                <p className="mb-0">
                  Digite uma nova senha de usuário
                  com no mínimo 8 caracteres e máximo de 63 caracteres, contendo:
                </p>
                <ul>
                  <li>
                    <p className="mb-0">Pelo menos 1 (um) número;</p>
                  </li>
                  <li>
                    <p className="mb-0">Pelo menos 1 (uma) letra maiúscula;</p>
                  </li>
                  <li>
                    <p className="mb-0">Pelo menos 1 (uma) letra minúscula;</p>
                  </li>
                  <li>
                    <p>Pelo menos 1 (um) caractere especial dentre os seguintes ${specialCharacters}</p>
                  </li>
                </ul>
                <p className="mb-0">Clique em entrar Senha.</p>
                <p className="justified-text">
                  Então o equipamento apresentará a tela inicial Dashboard e
                  estará pronto para iniciar as configurações de uso.
                </p>
                <p className="mb-0 justified-text">
                  <strong>Obs.:</strong> o produto da Intelbras vem com o
                  padrão IP 10.0.0.1. Contudo, receberá um novo endereço IP,
                  se for inserido em uma rede com DHCP, de acordo com a faixa
                  configurada no servidor DHCP. Para consultar o IP obtido,
                  verifique no seu servidor DHCP. Caso queira apenas acessar a
                  interface do produto, basta digitar meu.intelbras no seu navegador
                  em um computador na mesma rede do AP. Após o primeiro acesso, utilizar o
                  login admin e nova senha cadastrada.
                </p>
              </ul>
              <p className="mb-0">
                Caso você se esqueça da senha, é possível resetar o equipamento e configurá-lo novamente. Consulte a
                seção <a style={{ color: '#00A335' }} href="#reset-padrao-fabrica">Reset (padrão de fábrica)</a>

                para entender os procedimentos de reset físico e reset via software.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionProductAccess;
